// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import React, { ReactElement } from 'react';

import './SsoButton.scss';

interface SsoButtonProps {
    onClick: () => void;
}

const SsoButton = ({ onClick }: SsoButtonProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <THButton block className="sso-button" onClick={() => onClick()}>
            {i('login.sso')}
        </THButton>
    );
};

export default SsoButton;
